<div>
  <div class="truncate">{{ state.formattedValue }}</div>
</div>
